(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["FAQ"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.__gsgfaqInit) return;
  window.__gsgfaqInit = true;

  function norm(s){ return (s || '').toLowerCase().normalize('NFKD').replace(/[̀-ͯ]/g, ''); }
  function all(sel, ctx){ return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function setOpen(item, open){
    var btn = item.querySelector('.faq-q'), panel = item.querySelector('.faq-a');
    item.classList.toggle('open', open);
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (panel) panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
  }

  function buildNav(){
    var cats = all('.gsgfaq-lp .faq-category[data-title]').filter(function(c){ return c.id && c.getAttribute('data-title'); });
    all('[data-gsgfaq-nav]').forEach(function(nav){
      nav.innerHTML = '';
      cats.forEach(function(c){
        var a = document.createElement('a');
        a.href = '#' + c.id;
        a.textContent = c.getAttribute('data-title');
        nav.appendChild(a);
      });
      var bar = nav.closest('.catnav');
      if (bar) bar.style.display = cats.length ? '' : 'none';
    });
  }

  function filter(input){
    var raw = input.value.trim(), term = norm(raw), total = 0;
    all('.gsgfaq-lp .faq-category').forEach(function(cat){
      var shown = 0;
      all('.faq-item', cat).forEach(function(it){
        if (it.__q === undefined) it.__q = norm(it.getAttribute('data-q'));
        var match = term === '' || it.__q.indexOf(term) !== -1;
        it.classList.toggle('hidden', !match);
        if (match) { shown++; total++; } else if (it.classList.contains('open')) { setOpen(it, false); }
      });
      cat.style.display = shown === 0 ? 'none' : '';
      if (cat.id) all('[data-gsgfaq-nav] a[href="#' + cat.id + '"]').forEach(function(a){ a.style.display = shown === 0 ? 'none' : ''; });
    });
    var wrap = input.closest('.search-wrap'), count = wrap && wrap.querySelector('.search-count');
    if (!count) return;
    if (term === '') { count.classList.remove('show'); count.textContent = ''; }
    else {
      count.textContent = total === 0 ? 'Keine Treffer für "' + raw + '"' : total + ' Treffer für "' + raw + '"';
      count.classList.add('show');
    }
  }

  document.addEventListener('click', function(e){
    var btn = e.target.closest ? e.target.closest('.gsgfaq-lp .faq-q') : null;
    if (!btn) return;
    var item = btn.closest('.faq-item');
    setOpen(item, !item.classList.contains('open'));
  });

  document.addEventListener('input', function(e){
    if (e.target && e.target.matches && e.target.matches('.gsgfaq-lp [data-gsgfaq-search]')) filter(e.target);
  });

  window.addEventListener('resize', function(){
    all('.gsgfaq-lp .faq-item.open .faq-a').forEach(function(p){ p.style.maxHeight = p.scrollHeight + 'px'; });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', buildNav); else buildNav();

  /* Theme-Editor */
  document.addEventListener('shopify:section:load', buildNav);
  document.addEventListener('shopify:section:unload', function(){ setTimeout(buildNav, 0); });
  document.addEventListener('shopify:block:select', function(e){
    var item = e.target.closest && e.target.closest('.gsgfaq-lp .faq-item');
    if (item) setOpen(item, true);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
